import { toastify } from '@testsigma/atoms';

export const handleApiErrorMessages = (
  error: any,
  getTranslation: (i18nKey: string) => string,
  internalErrorMSG?: string,
  entityName?: string,
  entityType?: string,
) => {
  if (error.response) {
    const { status, data } = error.response;
    if (status === 422 || status === 451) {
      let errorMessage = data.error;
      if (
        errorMessage ===
          'Entity with same name already exists, Please use different name' &&
        Boolean(entityName)
      ) {
        errorMessage = errorMessage.replace('Entity', entityName);
        if (Boolean(entityType)) {
          errorMessage = errorMessage.replaceAll(
            'name',
            entityType.toLowerCase(),
          );
        }
      }
      toastify(errorMessage, {
        type: 'error',
        position: 'top-center',
        hideProgressBar: true,
      });
      return errorMessage;
    } else if (status === 500) {
      const errorMessage = data?.code
        ? getTranslation(data.code) || internalErrorMSG
        : data?.error || internalErrorMSG;
      toastify(errorMessage, {
        type: 'error',
        position: 'top-center',
        hideProgressBar: true,
      });
    } else if (data?.objectErrors?.length > 0) {
      toastify(getTranslation('common.duplicate_entity'), {
        type: 'error',
        position: 'top-center',
        hideProgressBar: true,
      });
    } else {
      toastify(data?.error || internalErrorMSG, {
        type: 'error',
        position: 'top-center',
        hideProgressBar: true,
      });
    }
  } else {
    toastify(internalErrorMSG, {
      type: 'error',
      position: 'top-center',
      hideProgressBar: true,
    });
  }
};

export const handleSessionExpired = () => {
  window.location.href = `${
    import.meta.env.VITE_ID_SERVICE_URL
  }logout?redirectTo=${window.location.href}`;
};
